import { render, staticRenderFns } from "./ComingSoon.html?vue&type=template&id=4f0f0052&external"
import script from "./ComingSoon.js?vue&type=script&lang=js&external"
export * from "./ComingSoon.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports